import React from 'react'
import { SidebarContainer, Icon, CloseIcon, SidebarMenu, SidebarWrapper, SidebarLink, SidebarRoute, SideBtnWrap} from './SidebarElements'

const TeamSidebar = ({isOpen, toggle}) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
        <Icon onClick={toggle}>
            <CloseIcon />
        </Icon>
        <SidebarWrapper>
            <SidebarMenu>
                <SidebarLink to="about us" onClick={toggle} smooth="true"  exact="true" offset={-80} >
                    About Us
                </SidebarLink>
                <SidebarLink to="our team" onClick={toggle} smooth="true"  exact="true" offset={-80} >
                    Our Team
                </SidebarLink>
                <SidebarLink to="history" onClick={toggle} smooth="true"  exact="true" offset={-80} >
                    History
                </SidebarLink>
                <SideBtnWrap>
                    <SidebarRoute to="/signin" onClick={toggle} smooth="true"  exact="true" offset={-80} >
                        Sign in
                    </SidebarRoute>
                </SideBtnWrap>
            </SidebarMenu>
        </SidebarWrapper>
    </SidebarContainer>
  )
}

export default TeamSidebar